export const TRAVEL_RULE_SUPPORT_URL =
  "https://support.moonpay.com/customers/docs/transaction-troubleshooting#transactions-unsuccessful-due-to-uk-crypto-travel-rule-compliance";
